var map = {
	"./360 deg Camera.svg": 8539,
	"./ALcometer.svg": 3571,
	"./Body Camera.svg": 8278,
	"./Desktop.svg": 8811,
	"./Drones.svg": 8084,
	"./Horizontal Signal.svg": 4583,
	"./Led Board.svg": 5508,
	"./Signal Status.svg": 1305,
	"./SpeedCam.svg": 2167,
	"./Swiping Machine.svg": 5395,
	"./Tab.svg": 646,
	"./Vertical Signal.svg": 4293,
	"./Warning Poles.svg": 1314,
	"./camera.svg": 7908,
	"./company.svg": 9382,
	"./item.svg": 2308,
	"./junction.svg": 3341,
	"./signals.svg": 4720,
	"./site.svg": 664,
	"./subsidairy.svg": 3362,
	"./walkie talkie.svg": 1392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6143;